import {gql} from 'apollo-boost';

export const GET_ASSESSMENTS = gql`
  query getAssessments{
    getAssessments {
      id
      nameLocal
      nameEng
    }
  }
`;

export const GET_ASSESSMENT = gql`
  query getAssessment($id : ID!){
    getAssessment (
      id: $id
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const ADD_ASSESSMENT = gql`
  mutation addAssessment(
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    addAssessment(
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const UPDATE_ASSESSMENT = gql`
  mutation updateAssessment(
    $id: ID!,
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    updateAssessment(
      id: $id
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const DELETE_ASSESSMENT = gql`
  mutation deleteAssessment($id: ID!) {
    deleteAssessment(
      id: $id
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

